'use client';

import TopSelector from '@fe-common-ui/Group/TopSelector/TopSelector';
import { styled } from '@linaria/react';
import { AI_TABS, AiCategory } from '@fe-news/constants/ai/type';
import Image from 'next/image';
import Link from 'next/link';
import { SCREEN_SIZE } from '@fe-news/styles/style';
import YuShan from './YuShan';
import AiGc from './AiGc';

const ContentWrapper = styled.div<{ isAiGc?: boolean }>`
  position: relative;
  background-color: white;
  padding: 0px 12px;
  margin-top: 12px;
  border-radius: 6px;
  border: solid 1px #e2e8f1;

  @media screen and (min-width: ${SCREEN_SIZE.DESKTOP}px) {
    padding: 16px 12px;
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: url('/assets/images/ai-bg.webp');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.3;

    z-index: 0;
  }
`;

const Container = styled.div<{ isAiGc?: boolean }>`
  position: relative;
  z-index: 1;

  height: ${({ isAiGc }) => (isAiGc ? '462px' : '385px')};

  @media screen and (min-width: ${SCREEN_SIZE.DESKTOP}px) {
    height: ${({ isAiGc }) => (isAiGc ? '462px' : '345px')};
  }
`;

const ReadMore = styled.div<{ isAiGc?: boolean }>`
  display: flex;
  align-items: center;
  position: absolute;
  left: 50%;
  bottom: 8px;
  transform: translateX(-50%);

  @media screen and (min-width: ${SCREEN_SIZE.DESKTOP}px) {
    bottom: ${({ isAiGc }) => (isAiGc ? '12px' : '-4px')};
  }
`;

type AsideAiNewsContentProps = {
  isAiGc: boolean;
  tab: AiCategory.AIGC_HOT | AiCategory.HEADLINE_AI | AiCategory.TW_STOCK_AI | AiCategory.WD_STOCK_AI;
  onChangeTab: (category: string | number) => void;
  url: string;
};

const AsideAiNewsContent = ({ isAiGc, tab, onChangeTab, url }: AsideAiNewsContentProps) => {
  return (
    <ContentWrapper isAiGc={isAiGc}>
      <Container isAiGc={isAiGc}>
        <TopSelector selectors={AI_TABS} selector={tab} onClick={onChangeTab} />
        {tab === AiCategory.AIGC_HOT ? (
          <AiGc isAiGc={isAiGc} />
        ) : (
          <>
            <YuShan type={tab} url={url} isAiGc={isAiGc} />
            <ReadMore isAiGc={isAiGc}>
              <Link href={url} prefetch={false}>
                <Image src='/assets/icons/icon-explore-more.png' alt='read-more' width={136} height={18} />
              </Link>
            </ReadMore>
          </>
        )}
      </Container>
    </ContentWrapper>
  );
};

export default AsideAiNewsContent;
